import { Env } from '@quirion/utils';

import { getAppMode } from './getAppMode';

export const isProd = () => {
  const appMode = getAppMode();

  return appMode === Env.Preproduction || appMode === Env.Production;
};
